var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHasImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.255,
    height: 10.255,
    viewBox: "0 0 10.255 10.255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "image_FILL0_wght400_GRAD0_opsz48",
    d: "M6.855,16.255A.876.876,0,0,1,6,15.4V6.855A.876.876,0,0,1,6.855,6H15.4a.876.876,0,0,1,.855.855V15.4a.876.876,0,0,1-.855.855Zm0-.855H15.4V6.855H6.855Zm.8-1.382h6.965l-2.094-2.792-1.88,2.436L9.319,11.854Zm-.8,1.382v0Z",
    transform: "translate(-6 -6)",
    fill: "#58585d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHasImages);
export default __webpack_public_path__ + "static/media/icon-has-images.9b9a0e55649ebf80a9b3189ee516a1e7.svg";
export { ForwardRef as ReactComponent };